import {
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogContentText as MuiDialogContentText,
  DialogTitle as MuiDialogTitle,
  type DialogProps as MuiDialogProps,
  type DialogActionsProps as MuiDialogActionsProps,
  type DialogContentProps as MuiDialogContentProps,
  type DialogContentTextProps as MuiDialogContentTextProps,
  type DialogTitleProps as MuiDialogTitleProps,
} from '@mui/material';
import { forwardRef } from 'react';

/**
 * FSE Dialog — thin wrapper over MUI Dialog plus its title/content/actions
 * subcomponents, so consumers get a modal / confirm primitive without importing
 * @mui/material directly (the @fse/ui swap-promise). Apply FSE defaults here as
 * patterns emerge (e.g. a default `maxWidth`); transparent passthrough for now.
 */
export type DialogProps = MuiDialogProps;
export type DialogTitleProps = MuiDialogTitleProps;
export type DialogContentProps = MuiDialogContentProps;
export type DialogContentTextProps = MuiDialogContentTextProps;
export type DialogActionsProps = MuiDialogActionsProps;

export const Dialog = forwardRef<HTMLDivElement, DialogProps>(function Dialog(props, ref) {
  return <MuiDialog ref={ref} {...props} />;
});

export const DialogTitle = MuiDialogTitle;
export const DialogContent = MuiDialogContent;
export const DialogContentText = MuiDialogContentText;
export const DialogActions = MuiDialogActions;
